<template>
  <div>
    <!--テーブル-->
    <el-main style="padding: 0px 0px 0px 0px; width: 100%;height: 100%;">
      <!--営業所時給-->
      <div class="search-module_k0003">
        <el-row style="text-align:center;" :gutter="20">
          <el-col>
            <div>
              <el-button type="text" style="color:#000000;padding: 0px 0px 0px 0px;" v-loading.fullscreen.lock="fullscreenLoading" size="mini" @click="previousDateClick" v-show="status1">＜＜</el-button>
              <span>{{titleDisplayDate}} </span>
              <el-button type="text" style="color:#000000;padding: 0px 0px 0px 0px;" v-loading.fullscreen.lock="fullscreenLoading" size="mini" @click="nextDateClick" v-show="status2">＞＞</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row style="padding-top: 5px;background-color: #ffffff; ">
        </el-row>
        <el-row style="border:1px solid #dfdfdf">
          <el-col :span="4" class="el-col_k0003" style=" border-bottom:1px solid #dfdfdf ;">
            <div class="grid-content bg-purple readonly_input div_input_k0003">
              <!--氏名-->
              <span class="input_span_k0003" style=" border-right:1px solid #dfdfdf;width:30%">{{$t('MODULE.K0003_LBL_NAME')}}</span>
              <span class="input_span_k0003" style="width:69%">{{hourwage.userName}} </span>
            </div>
          </el-col>
          <el-col :span="4" class="el-col_k0003" style=" border-bottom:1px solid #dfdfdf;">
            <div class="grid-content bg-purple readonly_input div_input_k0003">
              <!--スタッフCD-->
              <span class="input_span_k0003" style=" border-right:1px solid #dfdfdf;width:30%">{{$t('MODULE.K0003_LBL_USERID')}}</span>
              <span class="input_span_k0003" style="width:69%">{{hourwage.userCd}} </span>
            </div>
          </el-col>
          <el-col :span="5" class="el-col_k0003" style=" border-bottom:1px solid #dfdfdf;">
            <div class="grid-content bg-purple readonly_input div_input_k0003">
              <!--勤務営業所-->
              <span class="input_span_k0003" style=" border-right:1px solid #dfdfdf;width:30%">{{$t('MODULE.K0003_LBL_POINT')}}</span>
              <span class="input_span_k0003" style="width:69%">{{hourwage.affiliationPlace}} </span>
            </div>
          </el-col>
          <el-col :span="6" class="el-col_k0003">
            <div class="grid-content bg-purple readonly_input div_input_k0003">
              <!--累積勤務時間-->
              <span class="input_span_k0003" style=" border-right:1px solid #dfdfdf;width:30%">{{$t('MODULE.K0003_LBL_SUMWORKTIME')}}</span>
              <span class="input_span_k0003" style="width:69%">{{hourwage.sumWorkTime}} </span>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row style="padding-top: 5px;background-color: #ffffff; ">
      </el-row>
      <!--業務形態別-->
      <div class="el-detail_k0003">
        <el-row style="border:0px solid #dfdfdf; height: 35px;">
          <el-col :span="4" class="el-col_k0003" style=" border-bottom:0px solid #dfdfdf ;">
            <div class="grid-content bg-purple readonly_input div_input_k0003">
              <!--業務形態-->
              <span class="input_span_k0003" style=" border-right:0px solid #dfdfdf;width:30%">
                {{$t('MODULE.K0003_LBL_BUSINESSTYPE')}}
              </span>
              <div class="" style="width:55%">              
                <el-select v-model="businessTypeSelectKey" style="width:45%;" size="small"  @change="businessTypeSelect(businessTypeSelectKey)">
                  <el-option v-for="item in businessTypeList" :key="item.key" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-col>
        </el-row>
        <!--業務形態-->
        <el-table style="border: 0px solid #AAAAAA;" 
                  :header-cell-style="k0003HeaderStyle" 
                  :cell-style="k0003IsCellStyle" 
                  :header-row-class-name="k0003HeaderClass" 
                  :cell-class-name="k0003IsCellClass" 
                  :data="typeAllowanceList" max-height="380" border size="mini">
                  
          <!--手当名-->
          <el-table-column prop="col1" :label="$t('MODULE.K0003_LBL_BUSINESSTYPE_ALLOWANCE')" min-width="40%" width="">
            <template slot-scope="scope">
              {{scope.row.displayName}}
            </template>
          </el-table-column>
          <!--レベル-->
          <el-table-column prop="col1" :label="$t('MODULE.K0003_LBL_BUSINESSTYPE_SKILLLEVEL')" min-width="30%" width="">
            <template slot-scope="scope">
              {{scope.row.skillLevel}}
            </template>
          </el-table-column>
          <!--時給-->
          <el-table-column prop="col1" :label="$t('MODULE.K0003_LBL_BUSINESSTYPE_HOURWAGE')" min-width="30%" width="">
            <template slot-scope="scope">
              {{scope.row.allowance}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-row style="padding-top: 5px;background-color: #ffffff; ">
      </el-row>
      <!--案件手当-->
      <div class="el-detail_k0003">
        <el-table style="border: 0px solid #AAAAAA;" 
              :header-cell-style="k0003HeaderStyle" 
              :cell-style="k0003IsCellStyleAllowance" 
              :header-row-class-name="k0003HeaderClass" 
              :cell-class-name="k0003IsCellClass" 
              :data="allowanceList" height="380" border size="mini">
          <!--显示列-->
          <!--業務-->
          <el-table-column prop="col1" :label="$t('MODULE.K0003_LBL_GYOUMU')" min-width="15%" width="" align="center">
            <template slot-scope="scope">
              {{scope.row.businessType}}
            </template>
          </el-table-column>
          <!--企業名\現場CD-->
          <el-table-column prop="col2" :label="$t('MODULE.K0003_LBL_KIGYO')" min-width="35%" width="" align="center">
            <template slot-scope="scope">
              {{scope.row.companyName}}<br />
              {{scope.row.fieldCd}}
            </template>
          </el-table-column>
          <!--店舗名\店舗役職名-->
          <el-table-column prop="col3" :label="$t('MODULE.K0003_LBL_STORE')" min-width="28%" width="" align="center">
            <template slot-scope="scope">
              {{scope.row.storeName}}<br />
              {{scope.row.storePositionName}}
            </template>
          </el-table-column>
          <!--案件手当\時給単価（支払時給）-->
          <el-table-column prop="col4" :label="$t('MODULE.K0003_LBL_ALLOWANCE')" min-width="22%" width="" align="center">
            <template slot-scope="scope">
              {{scope.row.orderAllowance}}<br />
              {{scope.row.hourwageUnitPrice}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-main>
  </div>
</template>
<script>
import * as amsApi from "../api/k_0003"
import utilApi from '@/common/utils'
import locale from "element-ui/lib/locale/lang/ja"
import Vue from "vue"
import ElementUI from "element-ui"
let url = require('@/../config/sysConfig')
Vue.use(ElementUI, { locale })
export default {
  components: {
  },
  data() {
    return {
      titleDisplayDate: '',
      paramDate: '',
      retDateList: [],//param
      //スタッフ時給取得
      hourwage: {
        "userCd": '',
        "userName": '',
        "affiliationPlace": '',
        "sumWorkTime": ''
      },
      typeAllowanceList: [],//各手当時給情報取得
      allowanceList: [],//スタッフ案件手当取得

      businessTypeSelectKey: '1',
      businessTypeList: [],//業務形態区分
      
      status1: false,
      status2: true,
      fullscreenLoading: false,
    };
  },
  created() {
    // 初期化
    this.init_query();
  },
  mounted() {

  },
  methods: {
    // 初期化
    init_query() {

      //API「マスタデータ」の業務形態区分を呼出す。
      amsApi.conditionSearch('all', '50', 'business_type').then(res => {
        this.businessTypeList = res.items.generalData.businessType
      });

      //業務形態の選択値を変更すれば、変更後の選択値はLocalStorageに保存する。
      //画面初期値：LocalStorageから取得する。取得できない場合、STとする。
      var localStorageBusinessTypeSelect = localStorage.getItem('k0003_businessTypeSelectKey');
      if (JSON.parse(localStorageBusinessTypeSelect) != null) {
        this.businessTypeSelectKey = localStorageBusinessTypeSelect;
      } else {
        localStorage.setItem("k0003_businessTypeSelectKey", this.businessTypeSelectKey)
      }

      //API「対象年月取得」を呼出す。
      amsApi.k_0003_targetYm().then(res => {
        this.retDateList = res.items;
        if (this.retDateList.length < 2) {
          this.$message.warning({ message: this.$t('COMMON.MSG_TARGETYM'), showClose: true })
        } else {
          this.previousDateClick();
        }
      });

      // //対象年月の初期値：当月
      // var thisDate = utilApi.timeDefault();
      
      // //対象年月の月初末日（YYYY/MM/end）
      // thisDate = utilApi.getLastDayOfMonth(thisDate);
      // var preMonth = utilApi.getPreMonth(thisDate);

      // var thisRetDate = {
      //   "targetDate": thisDate,
      //   "crJudgeLevel": thisDate.split('/')[0] + this.$t('MODULE.K0003_LBL_YEAR') + thisDate.split('/')[1] + this.$t('MODULE.K0003_LBL_MONTH')
      // }
      // var preRetDate = {
      //   "targetDate": preMonth,
      //   "crJudgeLevel": preMonth.split('/')[0] + this.$t('MODULE.K0003_LBL_YEAR') + preMonth.split('/')[1] + this.$t('MODULE.K0003_LBL_MONTH')
      // }
      // this.retDateList = [];
      // this.retDateList.push(preRetDate);
      // this.retDateList.push(thisRetDate);
      // console.log(this.retDateList);

      // //年月範囲：前月と当月のみ表示。
      // this.nextDateClick();
    },

    //前一个月
    previousDateClick() {
      this.status1 = false;
      this.status2 = true;
      this.titleDisplayDate = this.retDateList[0].crJudgeLevel;
      this.paramDate = this.retDateList[0].targetDate;
      var Params = {
        'targetYm': this.paramDate,
        "businessType": this.businessTypeSelectKey
      }
      this.query(Params);
    },

    //下一个月
    nextDateClick() {
      this.status1 = true;
      this.status2 = false;
      this.titleDisplayDate = this.retDateList[1].crJudgeLevel;
      this.paramDate = this.retDateList[1].targetDate;
      var Params = {
        'targetYm': this.paramDate,
        "businessType": this.businessTypeSelectKey
      }
      this.query(Params);
    },

    query(Params) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(() => {
        loading.close()
      }, 2000);

      //2.1スタッフ時給取得
      amsApi.k_0003_hourwage(Params).then(res => {
        if (res.code === 429) {
          this.$message.warning({ message: this.$t('COMMON.MSG_NO_SUBJECT'), showClose: true });
          
          this.hourwage = {
            "userCd": '',
            "userName": '',
            "affiliationPlace": '',
            "sumWorkTime": ''
          };
          this.typeAllowanceList = [];
          this.allowanceList = [];

          loading.close();
          return;
        }
        if (res.code === 204) {
          this.hourwage.userCd = res.items[0].userCd;
          this.hourwage.userName = res.items[0].userName;
          this.hourwage.affiliationPlace = res.items[0].affiliationPlace;
          if (res.items[0].sumWorkTime != null) {
            this.hourwage.sumWorkTime = utilApi.decimalFormatter(parseFloat(res.items[0].sumWorkTime).toFixed(2));
          } else {
            this.hourwage.sumWorkTime = '';
          }

          //戻り値コードが「204」の場合、下記2.2の処理を続ける。
          //2.2各手当時給情報取得
          this.queryAllowance(loading, Params);

          //2.4スタッフ案件手当取得
          amsApi.k_0003_allowance(Params).then(res => {
            if (res.code === 204) {
              this.allowanceList = res.items;
              for (var i = 0; i < this.allowanceList.length; i++) {
                this.allowanceList[i].orderAllowance = this.NumericalFormatter_k0003(this.allowanceList[i].orderAllowance);
                this.allowanceList[i].hourwageUnitPrice = this.NumericalFormatter_k0003(this.allowanceList[i].hourwageUnitPrice);
              }
            } else {
              this.allowanceList = [];
            }
            loading.close();
          }).catch(err => {
            loading.close();
          });

        } else {
          this.hourwage = {
            "userCd": '',
            "userName": '',
            "affiliationPlace": '',
            "sumWorkTime": ''
          };
          this.typeAllowanceList = [];
          this.allowanceList = [];
          loading.close();
        }
      }).catch(err => {
        loading.close();
      });

    },

    //2.2各手当時給情報取得
    queryAllowance(loading, businessTypeSelectParams) {
       //2.2各手当時給情報取得
       amsApi.k_0003_typeAllowance(businessTypeSelectParams).then(res => {
        if (res.code === 204) {
          this.typeAllowanceList = res.items;
          for (var i = 0; i < this.typeAllowanceList.length; i++) {
            this.typeAllowanceList[i].allowance = this.NumericalFormatter_k0003(this.typeAllowanceList[i].allowance);
          }
          loading.close();
        } else {
          this.typeAllowanceList = [];
          loading.close();
        }
      }).catch(err => {
        loading.close();
      });
    },

    //画面表示変更、データ再表示
    businessTypeSelect(key) {
      //業務形態の選択値を変更すれば、変更後の選択値はLocalStorageに保存する。
      localStorage.setItem("k0003_businessTypeSelectKey", this.businessTypeSelectKey)

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(() => {
        loading.close()
      }, 2000);

       //2.2各手当時給情報取得
       var businessTypeSelectParams = {
         'targetYm': this.paramDate,
         "businessType": this.businessTypeSelectKey
       }
       this.queryAllowance(loading, businessTypeSelectParams);
    },

    //金额每三位加','
    NumericalFormatter_k0003(val) {
      if (val != null && val !== '') {
        var reg = /[^\d]/
        if (reg.test(val)) {
          val = val.toString().replace(/[^0-9]/ig, ',')
        }
        if (val.toString() !== '0' && val.toString() !== '0.0') {
          var regex = /^[0]+/
          val = val.toString().replace(regex, '')
        }
        return "￥" + val.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      } else {
        return ''
      }
    },
    // TABLEHeader样式
    k0003HeaderStyle({ row, column, rowIndex, columnIndex }) {
      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:10pt; '
    },
    // TABLE单元格样式
    k0003IsCellStyle({ row, colum, rowIndex, columnIndex }) {
      return 'text-align:center;fontSize:10pt'
    },
    k0003IsCellStyleAllowance({ row, colum, rowIndex, columnIndex }) {
      if (columnIndex == 2) {
        return 'text-align:left;fontSize:10pt'
      } else if(columnIndex == 3) {
        return 'text-align:right;fontSize:10pt'
      } else {
        return 'text-align:center;fontSize:10pt'
      }
    },
    k0003HeaderClass({ row, rowIndex }) {
      return 'k0003HeaderClass'
    },
    k0003IsCellClass({ row, rowIndex }) {
      return 'k0003IsCellClass'
    },
    // ログアウト処理
    log_out() {
      this.$message.closeAll()
      var vm = this
      vm.$router.push({ path: "/login" })
    }
  },

}

</script>
<style>
/*panel下全部区域*/
.all_area_k0003 {
  margin-left: 0px;
}
/*检索条件整体样式*/
.span_search_condition_k0003 {
  padding-left: 20px;
  font-size: 10pt;
  /* font-weight:bold;   */
}
/*下半部入力框内部长度 第一行*/
.textRight .el-input__inner {
  text-align: right;
}
.textLeft .el-input__inner {
  text-align: left;
}
/*按钮样式*/
.Location_k0003 {
  position: relative;
  top: 50%;
  left: 50%;
  height: 30%;
  text-align: center;
  padding: 20px;
}
/*上半部行样式*/
.el-row_k0003 {
  margin-bottom: 10px;
}
/*上半部列样式*/
.el-col_k0003 {
  /*border-radius: 4px;*/
  width: 100%;
  font-size: 10pt;
  text-align: center;
  /* padding:0px,50px,0px,20px; */
}

/*下半部span样式*/
.input_span_k0003 {
  /* display:block; */
  /* background-image: linear-gradient(#23b2e8,#017fad); */
  padding: 0px 0px 0px 0px;
  float: left;
  height: 30px;
  min-height: 30px;
  color: #5e5d5d;
  width: 30%;

  /* position:relative; */
  /* vertical-align:middle; */
}
/*下半部span样式*/
.input_span_k0003_header {
  /* display:block; */
  /* background-image: linear-gradient(#23b2e8,#017fad); */
  padding: 0px 0px 0px 0px;
  float: left;
  height: 30px;
  min-height: 30px;
  color: #ffffff;
  width: 30%;
  font-weight: bold;
  /* position:relative; */
  /* vertical-align:middle; */
}
.input_span2_k0003 {
  /* display:block; */
  /* background-image: linear-gradient(#23b2e8,#017fad); */
  float: left;
  height: 30px;
  min-height: 30px;
  color: #ffffff;
  width: 20%;
  /* position:relative; */
  /* vertical-align:middle; */
}
/*下半部span用div样式*/
.div_span_k0003 {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  width: 100%;
  height: 30px;
  line-height: 30px;
  /* position:relative; */
  overflow: hidden;
  /* background: #22b2e7; */
  margin: 0px;
  border: 0;
  padding: 0;
}
/*下半部input用div样式*/
.div_input_k0003 {
  width: 100%;
  height: 30px;
  line-height: 30px;
  /* position:relative; */
  /* overflow: hidden; */
  /* background: #d2eef8; */
  margin: 0px;
  border: 0;
  padding: 0;
  font-size: 10pt;
}

/*下半部整体div样式*/
.el-detail_k0003 {
  /* overflow-y:auto; */
  width: 100%;
  height: 100%;
  /* min-width: 400px; */
  /* border-style: solid;  */
  /* border-width: 1px; */
}
.el-input__inner {
  line-height: 20px;
}
/* 分割线上下外边距 */
.c0004-divider .el-divider--horizontal {
  margin-top: 8px;
  margin-bottom: 8px;
}
/*只读框字体颜色*/
.readonly_input .el-input .el-input__inner {
  border-color: rgb(228, 231, 237);
  color: #818181;
}
/*只读框字体颜色1*/
.readonly_input1 .el-input .el-input__inner {
  border-color: rgb(228, 231, 237);
  background-color: rgb(239, 240, 243);
  color: #acacaa;
}
/*input输入框*/
.css-input-width_k0003 {
  width: 72%;
}
.search-module_k0003 {
  padding-bottom: 0px;
  margin-bottom: 0px; /*检索模块与表格间距*/
  width: 100%;
  background-image: linear-gradient(#ffffff, #ffffff);

  /* border: solid 1px #999999; */
  /* box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);  */
}
/*面包屑*/
.el-crumb_k0003 {
  background-image: linear-gradient(#5c5d5d, #717171);
  padding-left: 5px;
  padding-top: 4px;
  height: 20px;
}
/*导航*/
.home-content-menu_k0003 {
  padding-left: 0;
  height: 40px;
  background-color: #23b2e8;
}

/*按钮激活和焦点样式*/
.css-btn_k0003:active,
.css-btn_k0003:focus {
  background-image: linear-gradient(0deg, #ffffff, #ffffff);
  color: #000000;
}
.k0003IsCellClass .cell {
  /* white-space: nowrap; */
  text-overflow: ellipsis;
  overflow: hidden;
}
.k0003HeaderClass .cell {
  white-space: pre-line;
}
</style>


// WEBPACK FOOTER //
// src/module/page/k_0003.vue